// Norwegian bokmål labels + semantic status colors. Codes mirror backend enums.

export const LEAD_STAGES = ["ny", "kontaktet", "kartlegging", "losningsforslag", "kalkyle", "tilbud_sendt", "forhandling", "vunnet", "tapt"];
export const MODULE_STATUSES = ["ledig", "reservert", "klargjoring", "transport", "pa_prosjekt", "service", "retur", "ikke_tilgjengelig"];
export const PROJECT_STATUSES = ["planlegging", "prosjektering", "klargjoring", "transport", "montasje", "overlevert", "i_drift", "demontering", "retur", "avsluttet"];
export const TRANSPORT_STATUSES = ["planlagt", "bestilt", "bekreftet", "pa_vei", "levert", "avvik", "fullfort"];
export const SERVICE_STATUSES = ["planlagt", "pagar", "venter", "fullfort", "avbrutt"];
export const SERVICE_TYPES = ["periodisk", "for_utsending", "etter_retur", "avvik", "manuell"];
export const ISSUE_STATUSES = ["ny", "under_behandling", "lost", "lukket"];
export const ISSUE_SEVERITIES = ["lav", "middels", "hoy", "kritisk"];
export const TASK_STATUSES = ["ikke_startet", "pagar", "fullfort", "avbrutt"];
export const TASK_TYPES = ["montasje", "demontasje", "klargjoring", "transport", "inspeksjon", "service", "annet"];
export const QUOTE_STATUSES = ["utkast", "sendt", "akseptert", "avslatt", "utlopt"];
export const CALC_STATUSES = ["utkast", "til_godkjenning", "godkjent", "laast"];
export const NEED_TYPES = ["innkvartering", "kontor", "kantine", "garderobe", "kombinasjon", "annet"];
export const RATE_CATEGORIES = ["personell", "prosjektering", "reise", "transport", "montasje", "eksternt", "annet"];
export const SUPPLIER_CATEGORIES = ["transport", "kran", "elektro", "vvs", "grunnarbeid", "montasje", "renhold", "service", "annet"];
export const DOCUMENT_CATEGORIES = ["tegninger", "fdv", "tilbud", "kontrakt", "soknad", "godkjenning", "bilde", "inspeksjon", "fakturagrunnlag", "bim", "annet"];
export const MODULE_CATEGORIES = ["bolig", "kontor", "kantine", "sanitaer", "garderobe", "teknisk", "lager", "annet"];
export const ALLOCATION_TYPES = ["reservert", "klargjoring", "transport", "prosjekt", "service", "retur"];
export const CALC_GROUPS = ["moduler", "etablering", "prosjektering", "personell", "transport", "montasje", "reise", "eksternt", "annet"];
export const ROLES = ["admin", "salg", "prosjektleder", "fleet", "felt", "ledelse", "operator"];
// økonomi
export const INVOICE_STATUSES = ["utkast", "til_godkjenning", "godkjent", "sendt", "delvis_betalt", "betalt", "forfalt", "kreditert", "annullert"];
export const CONTRACT_STATUSES = ["utkast", "signert", "aktiv", "utlopt", "oppsagt", "avsluttet"];
export const COST_STATUSES = ["mottatt", "til_godkjenning", "godkjent", "betalt", "bestridt", "avvist"];
export const COST_CATEGORIES = ["transport", "kran", "montasje", "elektro", "vvs", "grunnarbeid", "renhold", "service", "innkjop", "ferje", "annet"];
export const INVOICE_LINE_KINDS = ["leie", "etablering", "transport", "montasje", "demontering", "service", "opsjon", "annet"];

export const LABELS = {
  // lead stages
  ny: "Ny", kontaktet: "Kontaktet", kartlegging: "Kartlegging", losningsforslag: "Løsningsforslag", kalkyle: "Kalkyle", tilbud_sendt: "Tilbud sendt", forhandling: "Forhandling", vunnet: "Vunnet", tapt: "Tapt",
  // module statuses
  ledig: "Ledig", reservert: "Reservert", klargjoring: "Klargjøring", transport: "Transport", pa_prosjekt: "På prosjekt", service: "Service", retur: "Retur", ikke_tilgjengelig: "Ikke tilgjengelig",
  // project statuses
  planlegging: "Planlegging", prosjektering: "Prosjektering", montasje: "Montasje", overlevert: "Overlevert", i_drift: "I drift", demontering: "Demontering", avsluttet: "Avsluttet",
  // transport
  planlagt: "Planlagt", bestilt: "Bestilt", bekreftet: "Bekreftet", pa_vei: "På vei", levert: "Levert", avvik: "Avvik", fullfort: "Fullført",
  // service
  pagar: "Pågår", venter: "Venter", avbrutt: "Avbrutt", periodisk: "Periodisk", for_utsending: "Før utsending", etter_retur: "Etter retur", manuell: "Manuell",
  // issues
  under_behandling: "Under behandling", lost: "Løst", lukket: "Lukket", lav: "Lav", middels: "Middels", hoy: "Høy", kritisk: "Kritisk", normal: "Normal",
  // tasks
  ikke_startet: "Ikke startet", demontasje: "Demontasje", inspeksjon: "Inspeksjon", annet: "Annet",
  // quotes / calc
  utkast: "Utkast", sendt: "Sendt", akseptert: "Akseptert", avslatt: "Avslått", utlopt: "Utløpt", til_godkjenning: "Til godkjenning", godkjent: "Godkjent", laast: "Låst",
  // need types & categories
  innkvartering: "Innkvartering", kontor: "Kontor", kantine: "Kantine", garderobe: "Garderobe", kombinasjon: "Kombinasjon", bolig: "Bolig", sanitaer: "Sanitær", teknisk: "Teknisk", lager: "Lager",
  personell: "Personell", reise: "Reise", eksternt: "Eksterne kjøp", moduler: "Moduler / leie", etablering: "Etablering",
  kran: "Kran", elektro: "Elektro", vvs: "VVS", grunnarbeid: "Grunnarbeid", renhold: "Renhold",
  tegninger: "Tegninger", fdv: "FDV", tilbud: "Tilbud", kontrakt: "Kontrakt", soknad: "Søknad", godkjenning: "Godkjenning", bilde: "Bilde", fakturagrunnlag: "Fakturagrunnlag", bim: "BIM / Revit",
  prosjekt: "Prosjekt", aktiv: "Aktiv", kansellert: "Kansellert",
  // innkvartering – rooms (display status) and stays
  ledig_klar: "Ledig – klar", opptatt: "Opptatt", ma_rengjores: "Må rengjøres", ute_av_drift: "Ute av drift", ikke_aktiv: "Ikke aktiv",
  innsjekket: "Innsjekket", utsjekket: "Utsjekket",
  // roles
  admin: "Administrator", salg: "Salg", prosjektleder: "Prosjektleder", fleet: "Product/Fleet", felt: "Feltpersonell", ledelse: "Ledelse", operator: "Campoperatør",
  // misc
  utlevering: "Utlevering", intern: "Intern", ekstern: "Ekstern", nettside: "Nettside", referanse: "Referanse", messe: "Messe", "eksisterende kunde": "Eksisterende kunde",
  enkel: "Enkel", medium: "Medium", kompleks: "Kompleks",
  // økonomi
  delvis_betalt: "Delvis betalt", betalt: "Betalt", forfalt: "Forfalt", kreditert: "Kreditert", annullert: "Annullert", signert: "Signert", oppsagt: "Oppsagt", mottatt: "Mottatt", bestridt: "Bestridt", avvist: "Avvist",
  faktura: "Faktura", kreditnota: "Kreditnota", leie: "Leie", rammeavtale: "Rammeavtale", opsjon: "Opsjon", innkjop: "Innkjøp", ferje: "Ferje",
  manedlig: "Månedlig", kvartalsvis: "Kvartalsvis", engang: "Engang", kpi: "KPI-regulert", fast: "Fast sats", ingen: "Ingen", depositum: "Depositum", bankgaranti: "Bankgaranti", morselskapsgaranti: "Morselskapsgaranti",
  risiko: "Risiko", folg_opp: "Følg opp", ok: "OK", bank: "Bank", avtalegiro: "AvtaleGiro", kort: "Kort", motregning: "Motregning",
  // kapasitet
  kapasitet: "Kapasitetsplan", soft: "Soft hold", hard: "Kontraktsfestet", konvertert: "Kontraktsfestet", frigitt: "Frigitt", soft_hold: "Soft hold",
};

export const label = (code) => (code == null ? "" : LABELS[code] || String(code).replace(/_/g, " "));

// semantic tone per status. Colour is used only as a small dot; text stays neutral.
export const TONE_DOT = {
  neutral: "bg-slate-400",
  info: "bg-sky-500",
  success: "bg-emerald-500",
  warning: "bg-amber-500",
  danger: "bg-rose-500",
  primary: "bg-primary",
};
export const TONE_TEXT = {
  neutral: "text-muted-foreground",
  info: "text-sky-700 dark:text-sky-300",
  success: "text-emerald-700 dark:text-emerald-300",
  warning: "text-amber-700 dark:text-amber-300",
  danger: "text-rose-700 dark:text-rose-300",
  primary: "text-primary",
};
// legacy pill classes (quiet)
const TONES = {
  neutral: "bg-muted text-foreground/80 ring-transparent",
  info: "bg-muted text-foreground/80 ring-transparent",
  success: "bg-muted text-foreground/80 ring-transparent",
  warning: "bg-muted text-foreground/80 ring-transparent",
  danger: "bg-muted text-foreground/80 ring-transparent",
  primary: "bg-muted text-foreground/80 ring-transparent",
};

export const STATUS_TONE = {
  // lead
  ny: "info", kontaktet: "info", kartlegging: "warning", losningsforslag: "warning", kalkyle: "warning", tilbud_sendt: "neutral", forhandling: "warning", vunnet: "success", tapt: "danger",
  // module
  ledig: "success", reservert: "info", klargjoring: "warning", transport: "warning", pa_prosjekt: "neutral", service: "danger", retur: "info", ikke_tilgjengelig: "danger",
  // project
  planlegging: "info", prosjektering: "info", montasje: "warning", overlevert: "success", i_drift: "success", demontering: "warning", avsluttet: "neutral",
  // transport
  planlagt: "info", bestilt: "warning", bekreftet: "primary", pa_vei: "warning", levert: "success", avvik: "danger", fullfort: "success",
  // service/task/issue
  pagar: "warning", venter: "neutral", avbrutt: "neutral", ikke_startet: "info", under_behandling: "warning", lost: "success", lukket: "neutral",
  lav: "neutral", middels: "info", hoy: "warning", kritisk: "danger", normal: "neutral",
  // quote/calc
  utkast: "neutral", sendt: "info", akseptert: "success", avslatt: "danger", utlopt: "danger", til_godkjenning: "warning", godkjent: "success", laast: "neutral",
  aktiv: "success", kansellert: "neutral", prosjekt: "primary",
  // innkvartering
  ledig_klar: "success", opptatt: "neutral", ma_rengjores: "warning", ute_av_drift: "danger", ikke_aktiv: "neutral", innsjekket: "success", utsjekket: "neutral",
  // økonomi
  delvis_betalt: "warning", betalt: "success", forfalt: "danger", kreditert: "neutral", annullert: "neutral", signert: "info", oppsagt: "danger", mottatt: "info", bestridt: "danger", avvist: "neutral",
  risiko: "danger", folg_opp: "warning", ok: "success",
};

export const toneOf = (code) => STATUS_TONE[code] || "neutral";
export const toneClass = (code) => TONES[toneOf(code)];

// Gantt bar colors by allocation/bar type
export const BAR_COLORS = {
  prosjekt: "bg-primary text-white",
  reservert: "bg-sky-400 text-sky-950",
  klargjoring: "bg-amber-400 text-amber-950",
  transport: "bg-orange-500 text-white",
  service: "bg-rose-500 text-white",
  retur: "bg-sky-600 text-white",
  montasje: "bg-amber-500 text-white",
  demontasje: "bg-amber-700 text-white",
  inspeksjon: "bg-slate-500 text-white",
  annet: "bg-slate-400 text-white",
  project: "bg-slate-700 text-white",
};

export const NAV = [
  { to: "/", label: "Oversikt", icon: "LayoutDashboard", perm: "dashboard:read" },
  { to: "/henvendelser", label: "Henvendelser", icon: "Inbox", perm: "leads:read" },
  { to: "/kunder", label: "Kunder", icon: "Building2", perm: "customers:read" },
  { to: "/tilbud", label: "Tilbud", icon: "FileText", perm: "quotes:read" },
  { to: "/prosjekter", label: "Prosjekter", icon: "FolderKanban", perm: "projects:read" },
  { to: "/planlegging", label: "Planlegging", icon: "GanttChart", perm: "planning:read" },
  { to: "/moduler", label: "Flåte", icon: "Boxes", perm: "modules:read" },
  { to: "/kart", label: "Kart", icon: "Map", perm: "projects:read" },
  { to: "/assistent", label: "Assistent", icon: "Sparkles", perm: "ai:read" },
  { to: "/okonomi", label: "Økonomi", icon: "Coins", perm: "finance:read" },
  { to: "/innkvartering", label: "Innkvartering", icon: "BedDouble", perm: "innkvartering:read" },
  { to: "/service", label: "Service", icon: "Wrench", perm: "service:read" },
  { to: "/leverandorer", label: "Leverandører", icon: "Truck", perm: "suppliers:read" },
  { to: "/dokumenter", label: "Dokumenter", icon: "FolderOpen", perm: "documents:read" },
];
export const ADMIN_NAV = [
  { to: "/admin/priser", label: "Priser & kalkyle", icon: "Calculator", perm: "rates:read" },
  { to: "/admin/brukere", label: "Brukere & roller", icon: "Users", perm: "users:read" },
  { to: "/admin/innstillinger", label: "Systeminnstillinger", icon: "Settings", perm: "users:write" },
];

export const FIELD_NAV = { to: "/felt", label: "Mobil feltvisning", icon: "Smartphone", perm: "field:read" };

/**
 * Sidebar composition. Primary work (Oversikt, Kart, Salg, Drift) is always visible; everything secondary lives in a
 * collapsible «Mer» so the navigation reads as a short, calm list.
 */
export const NAV_GROUPS = [
  { id: "hjem", label: null, items: ["/", "/kart", "/assistent"] },
  { id: "salg", label: "Salg & økonomi", items: ["/henvendelser", "/kunder", "/tilbud", "/okonomi"] },
  { id: "drift", label: "Drift", items: ["/prosjekter", "/planlegging", "/moduler", "/innkvartering", "/service"] },
  { id: "mer", label: "Mer", collapsible: true, items: ["/leverandorer", "/dokumenter", "/admin/priser", "/admin/brukere", "/admin/innstillinger", "/felt"] },
];
export const NAV_BY_PATH = Object.fromEntries([...NAV, ...ADMIN_NAV, FIELD_NAV].map((n) => [n.to, n]));
